import Cookies from 'js-cookie'
let instance = null;

export default class GlobalStorage
{
  constructor()
  {
    if (!instance) {
      instance = this;
    }

    instance.html = instance.html || '';

    instance.totalPages = instance.totalPages || 1;

    instance.blobs = instance.blobs || {};

    instance.story = instance.story || {
        storyName:'香港故事',
        author:'香港人',
        description:'無數個懷才不遇的故事被遺棄在書桌抽屜、電腦硬碟及創作人的腦海裡鬱鬱而終。某一個故事不甘現狀作出垂死掙扎，一不留神跌進了tbc...',
        category:'ROMANCE',
        image:'',
        uuid:'',
        warningList:new Set(),
        suggested:false,
        type:"AMATEUR_STORY",
        channel:false,
    };
    
    instance.storyEpisode = instance.storyEpisode || {
      project_name: '故事序',
      author: '我的名字',
      sequence:'第一集',
      email: 'tbc@tbcstory.com',
      coverImage:null,
      coverImageURL:null,
      uuid:"",
      freePreview:true,
      publishDate:null,
      publishTime:null,
      order:0,
      items: [
        {title: `Scene`, type: `Scene`},
        {title: `Text`, type: `Text`,
            _attributes: {
              style: `bubble`,
              itemColor: "",
              position: `left`,
            },
            text: {enabled: true, _text: `新文字`+(1), _attributes: {
                "color": "#ffffff",
                "size": "medium",
                "style": "regular",
                "anim": "line"
              }},
            url:  {_text:``},
            name: {enabled: true, _text: `角色甲`, _attributes: {
                "color": "#ffffff",
                "size": "medium",
                "style": "regular"
              }},
            bg: {_attributes: {}}, sound: {_attributes: {}},
            overlay: {_attributes: {}, media: {_attributes: {}}},
          },          
      ],
      characters:[
          { id:"角色甲",
            text: {
                "color": "#ffffff",
                "size": "medium",
                "style": "regular",                
            },
            name: {
                "color": "#ffffff",
                "size": "medium",
                "style": "regular"
            },
            bubble_color:"#666666"            
          }         
      ]

    };

    instance.user = instance.user || {        
        token: null,
        refreshToken:null,
        reader:{
            uuid: null,
            countryCode: null,
            phoneNumber: null,
            email: null,
            ageGroup: null,
            gender: null,
            displayName: null,
            regType: null,
            avatar: null,
            storyAssociationList: null,
        }
      };

      instance.userStory = instance.userStory || {};
      instance.userStoryEpisodeList = instance.userStoryEpisodeList || {};

    return instance;
  }


  setTotalPages(data){
    this.totalPages=data;
  }

  getUserStory(){
      return this.userStory;
  }

  setUserStory(data){
    this.userStory = data;
  }

  getUserEpisodeList(){
        return this.userStoryEpisodeList;
    }

    setUserStoryEpisodeList(data){
    this.userStoryEpisodeList = data;
    }


  setStoryEpisode(json)
  {
    instance.storyEpisode = Object.assign(instance.storyEpisode || {}, json);
  }

  getHtml()
  {
    return this.html;
  }

  setHtml(data)
  {
      this.html=data;
  }

  getStory()
  {
    return this.story;
  }

  setStory(data)
  {
      this.story=data;
  }

  getStoryEpisode()
  {
    return this.storyEpisode;    
  }

  getStoryEpisodeWithOutAttachment()
  {
    return JSON.parse(JSON.stringify(this.storyEpisode, (k,v) => (k === 'base64_data')? undefined : v))    
  }

  getUser()
  {
    return this.user;
  }
  setUser(data)
  {
    this.user = data;
  }

  getStoryEpisodeItems()
  {
    return this.storyEpisode.items;
  }

  getCharacters()
  {
    return this.storyEpisode.characters;
  }

  clearCharacters()
  {
    this.storyEpisode.characters = [];
  }


  setCharacter(id)
  {
    var set;
    this.storyEpisode.characters.map((character,i)=>{
        if (character.id==id)
            set = character;
    })

    console.log(set);
    
    this.storyEpisode.items.map((item,i)=>
    {
        if ((item.type==='Text'  || item.type==='Media')  && item.name._text===id){
            console.log(item);
            item.name._attributes.color = set.name.color;
            item.name._attributes.size = set.name.size;
            item.name._attributes.style = set.name.style;
            item._attributes.itemColor = set.bubble_color
            item.text._attributes.color = set.text.color;
            item.text._attributes.size = set.text.size;
            item.text._attributes.style = set.text.style;       
            console.log(item);
        }
    });
  }

  
  addStoryEpisodeItem(type,index)
  {
    index = typeof index !== 'undefined' ? index : this.storyEpisode.items.length;
    if (type === `Scene`)
    {     
      this.storyEpisode.items.splice(index,0,{title: `Scene`, type: `Scene`});
    }
    else if (type === `Text`)
    {
        this.storyEpisode.items.splice(index,0,
          {title: `Text`, type: `Text`,
            _attributes: {
              style: `bubble`,
              itemColor: "",
              position: `left`,
            },
            text: {enabled: true, _text: `新文字`+(this.storyEpisode.items.length), _attributes: {
                "color": "#ffffff",
                "size": "medium",
                "style": "regular",
                "anim": "line"
              }},
            url:  {_text:``},
            name: {enabled: true, _text: `角色甲`, _attributes: {
                "color": "#ffffff",
                "size": "medium",
                "style": "regular"
              }},
            bg: {_attributes: {}}, sound: {_attributes: {}},
            overlay: {_attributes: {}, media: {_attributes: {}}},
          }
      );
    }
    else if (type === `Media`)
    {
        this.storyEpisode.items.splice(index,0,
          {title: `Media`, type: `Media`,
            _attributes: {
              style: `bubble`,
              itemColor: "",
              position: `left`,
              type:`image`,
              allowSkip: "false",
              autoDismiss: "false"
            },
            text: {enabled: true, _text: ``, _attributes: {
                "color": "#ffffff",
                "size": "medium",
                "style": "regular",
                "anim": "line"
              }},
            name: {enabled: true, _text: `角色甲`, _attributes: {
                "color": "#ffffff",
                "size": "regular",
                "style": "regular"
              }},   
            bg: {_attributes: {}}, sound: {_attributes: {}},
            overlay: {_attributes: {}, media: {_attributes: {}}},
            media: {_attributes: {
                secondarySrc:"",
                secondaryType:"image",
                src:"",
                type:"image"
            }}
            
          },
      )
    }
    else if (type === `Narrative`)
    {
        this.storyEpisode.items.splice(index,0,
            {title: `Narrative`, type: `Narrative`,
            _attributes: {
            style: `narrative`,
            itemColor: "",
            position: `center`,
            anim:"move_left"
            },
            text: {enabled: true, _text: `新文字`+(this.storyEpisode.items.length), _attributes: {
                "color": "#ffffff",
                "size": "medium",
                "style": "regular",
                "anim": "line"
            }},
            url:  {_text:``},
            name: {enabled: false, _text: ``, _attributes: {
                "color": "",
                "size": "",
                "style": ""
            }},
            bg: {_attributes: {}}, sound: {_attributes: {}},
            overlay: {_attributes: {}, media: {_attributes: {}}},
        },
      )
    }
    //console.log(this.storyEpisode.items);
    
  }

  addCharacter(name)
  {
    this.storyEpisode.characters.push(
    { id:name,
        text: {
            "color": "#ffffff",
            "size": "medium",
            "style": "regular",                
        },
        name: {
            "color": "#ffffff",
            "size": "medium",
            "style": "regular"
        },
        bubble_color:"#666666"            
      }    
    );    
  }

  parseStoryEpisodeItemsToJsonObject()
  {
    var scene_to_obj = (scene, cursor, story_items) => {
      var j = {
        "_attributes": {
          "id": "1"
        },
        "meta": {
          "_attributes": {
            "type": "content",
            "style": "message",
            "anim": "line",
            "allowSkip": "false"
          }
        },
        "items": {
          "item": []
        }
      };

      var items = [];

      for (var k = cursor + 1; k < story_items.length; k++)
      {
        var it = story_items[k];
        if (it.type === 'Scene')
        {
          break;
        }
        items.push(item_to_obj(it));
      }

      j.items.item = items;
      return j;
    }


    var     item_to_obj = (item) => {
      var z = {
        "_attributes": {
          "id": "6",
          "type": "text",
          "style": "narrative",
          "itemColor": "",
          "anim": "",
          "position": "center",
          "vibration": "",
          "allowSkip": "false",
          "autoDismiss": "false"
        },
      }
    
    if (global.DEBUG){
        console.log("item_to_obj//");
        console.log(item);
    }

      if (item._attributes)
      {
        z._attributes = Object.assign(z._attributes, item._attributes);
      }

      if (item.text.enabled)
      {
        z.text = item.text;
      }

      if (item.url && item.url._text)
      {
        z.url = item.url._text;        
      }

      if (item.name.enabled)
      {
        z.name = item.name;
      }

      if (item.bg.enabled)
      {
        z.bg = item.bg;
      }

      if (item.sound.enabled)
      {
        z.sound = item.sound;
      }

      if (item.overlay.enabled)
      {
        z.overlay = {_attributes: {
            "timing": "after",
            "vibration": "",
            "anim": "line",
            "position": "center",
            "allowSkip": "false",
            "autoDismiss": "false"
        }, media: {_attributes: {}}};
        Object.assign(z.overlay._attributes, item.overlay._attributes);

        if (item.overlay.media.enabled)
        {
          Object.assign(z.overlay.media._attributes, item.overlay.media._attributes);
        }

        

      }

      if (item.hasOwnProperty('media'))
      {          
        z.media = {_attributes: {
            "src": "",
            "type": "image",
            "secondarySrc": "",
        }};            
          Object.assign(z.media._attributes, item.media._attributes);
        }   

      if (global.DEBUG){
        console.log("item//");  
        console.log(item)
        console.log("parseStoryEpisodeItemsToJsonObject//");
        console.log(z);
      }
      return z;
    }


    var json = {
      "_declaration": {
        "_attributes": {
          "version": "1.0",
          "encoding": "UTF-8",
          "standalone": "yes"
        }
      },

      "scenes": {
        "_attributes": {
          "version": "0.8.1"
        },

        "scene": []
      }
    }



    var cursor = -1;
    var scenes = [];

    for (var k = cursor + 1; k < this.storyEpisode.items.length; k++)
    {
      var it = this.storyEpisode.items[k];
      if (it.type !== 'Scene')
      {
        continue;
      }
      scenes.push(scene_to_obj(it, k, this.storyEpisode.items));
    }

    json.scenes.scene = scenes;
    return json;
  }

    logout(){

        this.setUser({        
            token: null,
            refreshToken:null,
            reader:{
                uuid: null,
                countryCode: null,
                phoneNumber: null,
                email: null,
                ageGroup: null,
                gender: null,
                displayName: null,
                regType: null,
                avatar: null,
                storyAssociationList: null,
            }
          });
          this.setUserStory({});
          this.setUserStoryEpisodeList({});

          Cookies.remove('reader')
          Cookies.remove('reader_token')
      
      
          this.setStory({
                  storyName:'香港故事',
                  author:'香港人',
                  description:'無數個懷才不遇的故事被遺棄在書桌抽屜、電腦硬碟及創作人的腦海裡鬱鬱而終。某一個故事不甘現狀作出垂死掙扎，一不留神跌進了tbc...',
                  category:'ROMANCE',
                  image:'',
                  uuid:'',
                  warningList:new Set(),
                  suggested:false,
                  type:"AMATEUR_STORY"
              });
      
      
          this.setStoryEpisode(
          {
                project_name: '故事序',
                author: '我的名字',
                sequence:'第一集',
                email: 'tbc@tbcstory.com',
                coverImage:null,
                coverImageURL:null,
                freePreview:true,
                publishDate:null,
                publishTime:null,
                order:0,
                uuid:"",
                items: [
                  {title: `Scene`, type: `Scene`},
                  {title: `Text`, type: `Text`,
                      _attributes: {
                        style: `bubble`,
                        itemColor: "",
                        position: `left`,
                      },
                      text: {enabled: true, _text: `新文字`+(1), _attributes: {
                          "color": "#ffffff",
                          "size": "medium",
                          "style": "regular",
                          "anim": "line"
                        }},
                       url:  {_text:``},    
                      name: {enabled: true, _text: `角色甲`, _attributes: {
                          "color": "#ffffff",
                          "size": "medium",
                          "style": "regular"
                        }},
                      bg: {_attributes: {}}, sound: {_attributes: {}},
                      overlay: {_attributes: {}, media: {_attributes: {}}},
                    },          
                ],
                characters:[
                    { id:"角色甲",
                      text: {
                          "color": "#ffffff",
                          "size": "medium",
                          "style": "regular",                
                      },
                      name: {
                          "color": "#ffffff",
                          "size": "medium",
                          "style": "regular"
                      },
                      bubble_color:"#666666"            
                    }         
                ]
      
              });
                      
       
    }
}







/*
[Log] {
    "_declaration": {
        "_attributes": {
            "version": "1.0",
            "encoding": "UTF-8",
            "standalone": "yes"
        }
    },
    "scenes": {
        "_attributes": {
            "version": "0.8.1"
        },
        "scene": [
            {
                "_attributes": {
                    "id": "1"
                },
                "meta": {
                    "_attributes": {
                        "type": "content",
                        "style": "message",
                        "anim": "line",
                        "allowSkip": "false"
                    }
                },
                "items": {
                    "item": [
                        {
                            "_attributes": {
                                "id": "6",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "失物博物館是一個展覽別人遺失之物的地方。這裡的展品有些是被人遺忘，有些是有人刻意留下。"
                            },
                            "bg": {
                                "_attributes": {
                                    "type": "image",
                                    "src": "mus",
                                    "color": "#000000"
                                }
                            },
                            "sound": {
                                "_attributes": {
                                    "src": "short",
                                    "loop": ""
                                }
                            }
                        },
                        {
                            "_attributes": {
                                "id": "7",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "一雙鞋、一封信、一個人，甚至一句話都可以放在這裡作展覽。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "8",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "但是由你決定把它們放下的那一刻起，它們便不再屬於你，擁有權全歸博物館所有。"
                            }
                        }
                    ]
                }
            },
            {
                "_attributes": {
                    "id": "2"
                },
                "meta": {
                    "_attributes": {
                        "type": "content",
                        "style": "message",
                        "anim": "line",
                        "allowSkip": "false"
                    }
                },
                "items": {
                    "item": [
                        {
                            "_attributes": {
                                "id": "12",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷今年四十歲，現於一間小型餐廳工作，月入萬餘元，樣貌平平無奇，也不見得聰慧過人，說穿了便是一個普通得沒辦法更普通的女性，同時也是我們博物館的最大贊助單位。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "13",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "兒時玩伴"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這個毛公仔送我可好？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "14",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "兒時李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "嗯。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "15",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "一個毛公仔送到我們的博物館。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "16",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "同學"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "你成績比我好多了，一會兒Oral口試讓讓我吧？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "17",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "求學時李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "嗯。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "18",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "一個升學機會送到我們的博物館。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "19",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "男朋友"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我們分手吧。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "20",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "半年前的李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "嗯。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "21",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "一個男朋友送到我們的博物館。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "22",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "餐廳老闆"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "對不起，我們要解僱你。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "23",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "現在的李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "嗯。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "24",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "一份工作送到我們的博物館。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "25",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "由這刻起李倩婷便成為了一個一無所有的女人，同時李倩婷所提供的展品實在太多了，我們失物博物館無法處理那龐大的展覽品數量，出現了爆棚的情況。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "26",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "於是我便致電李倩婷。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "27",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "你好，請問是不是李倩婷女士？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "28",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我是。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "29",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這裡是失物博物館，首先要多謝李女士一直以來的捐贈。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "30",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "但由於李女士所提供的捐贈物實在太多，我們博物館沒有足夠位置存放，展示。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "31",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "所以想請李女士抽空過來，揀選一些別具意義的東西留下展覽，其餘不重要的，我們都不要了。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "32",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "好，就明天。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "33",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "感謝你一直以來的幫忙，明天見。"
                            }
                        }
                    ]
                }
            },
            {
                "_attributes": {
                    "id": "3"
                },
                "meta": {
                    "_attributes": {
                        "type": "content",
                        "style": "message",
                        "anim": "line",
                        "allowSkip": "false"
                    }
                },
                "items": {
                    "item": [
                        {
                            "_attributes": {
                                "id": "37",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷踏入了失物博物館大堂。"
                            },
                            "bg": {
                                "_attributes": {
                                    "type": "image",
                                    "src": "mus",
                                    "color": "#000000"
                                }
                            }
                        },
                        {
                            "_attributes": {
                                "id": "38",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "大堂亮麗無比，柔柔的光線照在一道迴旋樓梯上氣派十足。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "39",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "歡迎你啊，李女士。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "40",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "你好。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "41",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "事不宜遲，請。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "42",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我帶著李倩婷踏上迴旋樓梯，然後到達一條專門放著李倩婷展品的長廊。"
                            },
                            "bg": {
                                "_attributes": {
                                    "type": "image",
                                    "src": "hall",
                                    "color": "#000000"
                                }
                            }
                        },
                        {
                            "_attributes": {
                                "id": "43",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "長長的走廊可以說是記錄了李女士四十年來的點點滴滴。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "44",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李女士，請看看你的右手邊。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "45",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這是你半年前遺下的男朋友，我們有把他好好保存啊。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "46",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "嗯。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "47",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這東西對你來說還重要嗎？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "48",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "還需要留下嗎？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "49",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷苦笑回應。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "50",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我也不知道，不如我看完全部再答你？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "51",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "是的，是的，是我心急了。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "52",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "的確，要「真正」捨棄，並不容易，不是一時三刻可以下決定的。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "53",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "對吧？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "54",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我望著長廊上那無數的展品，心中產生了這個充滿矛盾的問題。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "55",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "請再看看你的左手邊，是你二十三年前所放棄的升學機會。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "56",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷望著升學機會，眼神變得複雜起來。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "57",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "最終⋯⋯"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "58",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "那個與我一同進入考場的同學，會考成績比我高一分。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "59",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "原校升讀，兩年後成功入讀大學。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "60",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "而我就到了一間餐廳打工，一做便是二十多年。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "61",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "你⋯⋯後悔嗎？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "62",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷望著升學機會，靜默片刻⋯⋯"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "63",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "最終她沒有回答我，轉身繼續向前行。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "64",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "也許「後悔」就是現在唯一能表達李倩婷心情的詞語。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "65",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "原來這四十年間李倩婷遺下過這麼多東西。如果她當初不願意把它們留下，嘗試挽留，現在的她又會變成怎麼樣？"
                            }
                        }
                    ]
                }
            },
            {
                "_attributes": {
                    "id": "4"
                },
                "meta": {
                    "_attributes": {
                        "type": "content",
                        "style": "message",
                        "anim": "line",
                        "allowSkip": "false"
                    }
                },
                "items": {
                    "item": [
                        {
                            "_attributes": {
                                "id": "69",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "然後我們經過一個叫雜物展區的展覽廳，裡面堆放著李倩婷曾經放棄過的種種瑣瑣碎碎的小物件。小物件堆成小山甚是壯觀！"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "70",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這裡的展品看來不太重要，應該可以全都棄掉吧？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "71",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這時，李倩婷好像發現了甚麼，瘋了般衝入雜物堆成的小山，不斷往雜物堆深處翻找。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "72",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我望著她那發了狂般的神態，實在有點吃驚。因為李倩婷一直都是處於極度平靜的狀態，就算見到「前男友」和「升學機會」她也不曾有過這麼大反應。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "73",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我甚至開始期待，她最終會找出甚麼珍寶出來。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "74",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "大約兩分鐘後⋯⋯"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "75",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷手抱住一個殘舊的毛公仔出來。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "76",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "你這麼著緊，就是為了這個毛公仔？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "77",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "嗯⋯⋯"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "78",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這是我父母送給我的最後一份生日禮物。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "79",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "他們生前最後一份禮物。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "80",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷把殘舊的毛公仔抱得更緊。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "81",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "你居然將這麼重要的東西送給別人？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "82",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我把它送了出去後不久，我父母因交通意外離世了。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "83",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "如果我預先知道，我肯定不會把她送出去。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "84",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我輕輕搖頭。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "85",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "預先知道嗎？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "86",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "有時「失去」是突如其來的，亦可以是選擇。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "87",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "明明經歷過這麼沉重的「失去」，為何你往後的日子仍是選擇拋棄這麼多？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "88",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷思考著這句說話，回想起自己的一生。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "89",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "對啊，明明自己已失去了這麼多，為何往後的日子卻沒有珍惜過自己所擁有的一切。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "90",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "明明這一切一切都可以是非常重要⋯⋯"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "91",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "「毛公仔」可以是父母給我的最後禮物。「升學機會」可以是為我帶來更好工作的契機。「前男友」可以是伴我廝守一生的丈夫。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "92",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "想著想著李倩婷的眼睛通紅，更眼有淚光。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "93",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這是我們最後的展品了。"
                            },
                            "bg": {
                                "_attributes": {
                                    "type": "image",
                                    "src": "mir",
                                    "color": "#000000"
                                }
                            },
                            "sound": {
                                "_attributes": {
                                    "src": "short",
                                    "loop": ""
                                }
                            }
                        },
                        {
                            "_attributes": {
                                "id": "94",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "我把李倩婷帶到一個白色的展覽台上，台上放有一塊全身鏡。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "95",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "全身鏡的鏡框以白銀打造，在展覽台的射燈映照下高貴奪目，絕對稱得上是本館最有價值的展品。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "96",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "有一點需要更正﹐這才是你父母送給你的最後一份禮物。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "97",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "遺下的時間⋯⋯不詳⋯⋯"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "98",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "李倩婷呆了呆﹐然後身體不由自主的一步一步踏上展覽台，然後一臉不可思議的輕撫著鏡框。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "99",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "而展品的名稱為──「自己」⋯⋯"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "100",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "原本已眼有淚光的李倩婷望著鏡中的自己，再也禁不住眼淚﹐淚水不斷的落下。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "101",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "多少年沒有哭過？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "102",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "連李倩婷自己也記不起了，也許人越大失去的東西越多，第一次失去你會痛，第二次，第三次就不怎麼痛了。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "103",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "\t痛著痛著你就習慣了，可笑是慣著慣著，你便會不知不覺的把自己也遺下⋯⋯"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "104",
                                "type": "text",
                                "style": "narrative",
                                "itemColor": "",
                                "anim": "",
                                "position": "center",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "所謂的「遺下時間不詳」就是這個意思。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "105",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這塊鏡不再值得展示了！"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "106",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "哈？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "107",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7c3b6f",
                                "anim": "",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "李倩婷"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "既然不用再展覽，可否將它還給我？"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "108",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "不，我們博物館列明了規則，遺下的東西是不可取回的。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "109",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "就算它被認定沒有展示價值，也只好把它銷毀。"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "110",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#7a7a7a",
                                "anim": "",
                                "position": "left",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "我"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "這是博物館規則，亦是世界的規則⋯⋯"
                            },
                            "overlay": {
                                "_attributes": {
                                    "timing": "after",
                                    "vibration": "",
                                    "anim": "line",
                                    "position": "center",
                                    "allowSkip": "false",
                                    "autoDismiss": "false"
                                },
                                "media": {
                                    "_attributes": {
                                        "type": "video",
                                        "src": "call"
                                    }
                                }
                            }
                        },
                        {
                            "_attributes": {
                                "id": "111",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#ffee00",
                                "anim": "line",
                                "position": "right",
                                "vibration": "",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "tbc... Original"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#000000",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "故事創作：田少"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "112",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#ffee00",
                                "anim": "line",
                                "position": "right",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "tbc... Original"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#000000",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "美術設計：KS、Sukey"
                            }
                        },
                        {
                            "_attributes": {
                                "id": "113",
                                "type": "text",
                                "style": "bubble",
                                "itemColor": "#ffee00",
                                "anim": "line",
                                "position": "right",
                                "allowSkip": "false",
                                "autoDismiss": "false"
                            },
                            "name": {
                                "_attributes": {
                                    "color": "#ffffff",
                                    "size": "regular",
                                    "style": "regular"
                                },
                                "_text": "tbc... Original"
                            },
                            "text": {
                                "_attributes": {
                                    "color": "#000000",
                                    "size": "medium",
                                    "style": "regular",
                                    "anim": "line"
                                },
                                "_text": "製作：田少"
                            }
                        }
                    ]
                }
            }
        ]
    }
}
 */